import { Button, List, Space, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import configuration from '../../../../../configuration'
import BookmarkModal from './BookmarkModal'
import { SettingOutlined, CloseOutlined } from '@ant-design/icons'
import {
  ButtonActionBar,
  Button as ButtonCore,
  Typography as TypographyCore,
} from 'modules/core/components'

const { Text, Title } = Typography

const BookmarkSide = ({ onClick, bookmarks, listBookmarks, setOpenBookmark, openBookmark }) => {
  const { t } = useTranslation()

  const [initLoading, setInitLoading] = useState(true)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [list, setList] = useState([])
  const [page, setPage] = useState(2)
  const [showBookmarkedit, setShowBookmarkedit] = useState(false)
  const [bookmark, setBookmark] = useState(null)

  useEffect(() => {
    setInitLoading(false)
    setData(bookmarks.data)
    setList(bookmarks.data)
  }, [bookmarks])

  const onLoadMore = () => {
    setLoading(true)
    listBookmarks({ page: page, page_size: 10 }).then((res) => {
      const newData = data.concat(res.payload.data.results)
      setData(newData)
      setList(newData)
      setLoading(false)
      setPage(page + 1)
    })
  }

  const loadMore =
    !initLoading && !loading && bookmarks.info.total > data.length ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
        }}
      >
        <Button onClick={onLoadMore}>Cargar Mas</Button>
      </div>
    ) : null

  const onClickEdit = (item) => {
    setShowBookmarkedit(true)
    setBookmark(item)
  }

  return (
    <Space style={{ width: '100%' }} direction="vertical">
      <ButtonActionBar position="space-between">
        <Title level={5}>{t('LABEL_BOOKMARKS')}</Title>
        <ButtonCore.Icon
          title="Cerrar"
          icon={<TypographyCore.Icon level={2} icon={CloseOutlined} />}
          onClick={() => setOpenBookmark(!openBookmark)}
        />
      </ButtonActionBar>
      <List
        style={{ height: window.innerHeight - 250 }}
        loading={initLoading}
        loadMore={loadMore}
        dataSource={list}
        size="small"
        renderItem={(item) => (
          <List.Item
            actions={[
              <Button
                type={'link'}
                onClick={() => onClickEdit(item)}
                icon={<SettingOutlined />}
              ></Button>,
            ]}
          >
            <Button
              block
              type={'text'}
              key={item.id}
              onClick={() => onClick(item)}
              title={`${item.name} - ${item.url}`}
              style={{ textAlign: 'left', width: '200px' }}
            >
              <Text style={{ width: 170 }} ellipsis>
                {item.name}
              </Text>
            </Button>
          </List.Item>
        )}
      />
      <BookmarkModal
        bookmark={bookmark}
        showBookmark={showBookmarkedit}
        setShowBookmark={setShowBookmarkedit}
      />
    </Space>
  )
}

const mapStateToProps = (state) => ({
  bookmarks: configuration.selectors.getBookmarks(state),
  openBookmark: configuration.selectors.getOpenBookmarks(state),
})

const mapDispatchToProps = {
  listBookmarks: configuration.actions.listBookmarks,
  setOpenBookmark: configuration.actions.setOpenBookmark,
}

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkSide)
